import Cookies from 'js-cookie'
const TokenKey = 'tw-token'

export function getToken () {
  return Cookies.get(TokenKey)
}

export function setToken (token) {
  return Cookies.set(TokenKey, token, {
    expires: new Date(Date.now() + 3600000000) // token有效期: 60分钟
  })
}

export function removeToken () {
  return Cookies.remove(TokenKey)
}
